import React from 'react';
import { app } from '@ekuaibao/whispered';
import { Popover, Tag, Tooltip } from '@hose/eui';
import { get } from 'lodash';
import Money from '../../../puppet/Money';
import styles from '../FlowLogItemWrapper.module.less';
export var PayeeInfoPopover = function (props) {
    var _a = props.paymentInfos, paymentInfos = _a === void 0 ? [] : _a, _b = props.showCode, showCode = _b === void 0 ? false : _b, _c = props.showFailureReason, showFailureReason = _c === void 0 ? false : _c, children = props.children;
    if (!paymentInfos || !paymentInfos.length) {
        return null;
    }
    return (React.createElement(Popover, { title: i18n.get('收款信息'), content: React.createElement("div", { className: styles['flow-plan-log-payment-wrapper'] }, paymentInfos.map(function (payment, index) {
            return (React.createElement("div", { key: index, className: "payment-content" },
                payment.feeTypeId ? (React.createElement("div", { className: "payment-row" },
                    React.createElement("div", { className: "title" }, i18n.get('费用类型') + "\uFF1A"),
                    React.createElement("div", { className: "content" }, get(payment, 'feeTypeId.name')))) : null,
                payment.code && showCode ? (React.createElement("div", { className: "payment-row" },
                    React.createElement("div", { className: "title" }, i18n.get('编码') + "\uFF1A"),
                    React.createElement("div", { className: "content" }, payment.code))) : null,
                React.createElement("div", { className: "payment-row" },
                    React.createElement("div", { className: "title" }, i18n.get('支付金额') + "\uFF1A"),
                    React.createElement("div", { className: "content" },
                        React.createElement(Money, { className: "dis-ib", value: payment.amount || 0 }))),
                React.createElement("div", { className: "payment-row" },
                    React.createElement("div", { className: "title" }, i18n.get('收款账户') + "\uFF1A"),
                    React.createElement("div", { className: "content" }, get(payment, 'payeeId.name'))),
                showFailureReason ? (React.createElement("div", { className: "payment-row" },
                    React.createElement("div", { className: "title" }, i18n.get('失败原因') + "\uFF1A"),
                    React.createElement("div", { className: "content" }, payment.respMsg || i18n.get('无')))) : null));
        })) }, children));
};
export var ConditionApporveTipView = function (props) {
    var node = props.node;
    var showConditionInBill = get(node, 'config.showConditionInBill');
    showConditionInBill = showConditionInBill === undefined ? true : showConditionInBill;
    if (!showConditionInBill || !node || !node.conditionalDescription) {
        return null;
    }
    var userInfo = app.getState('@common.userinfo.data');
    var conditionText = node.conditionalDescription;
    if (node.approverId && conditionText) {
        conditionText =
            userInfo.staff.id === node.approverId.id
                ? conditionText.replace(i18n.get('需要此环节审批'), i18n.get('需要您审批'))
                : conditionText;
    }
    return (React.createElement(Tooltip, { placement: "bottom", title: conditionText },
        React.createElement("div", { style: { marginTop: '8px', marginRight: '8px' } },
            React.createElement(Tag, { size: "small" }, i18n.get('条件')))));
};
